import { makeRequest, CommonRequestOptions } from '../makeRequest';

export type Tag = {
   type: string;
   name: string;
};

export type QuizTags = {
   learnosityid: string;
   tags: Tag[];
};

export type GetTagsForQuizzesResponse = QuizTags[];

export type GetTagsForQuizzesOptions = CommonRequestOptions & {
   learnosityReferences: string[];
};

export async function getTagsForQuizzes(
   { apiClient, ...body }: GetTagsForQuizzesOptions = { learnosityReferences: [] }
): Promise<GetTagsForQuizzesResponse> {
   return makeRequest('post', '/quizzes/learnosity/getTagsForQuizzes', {
      apiClient,
      body,
   });
}
